export const SymbolType = {
  REGULAR: 'Regular',
  COLOR: 'Color'
};
export const SymbolColor = {
  PRIMARY_CONTRAST: 'primary_contrast',
  SECONDARY_CONTRAST: 'secondary_contrast',
  NEGATIVE_CONTRAST: 'negative_contrast',
  POSITIVE_CONTRAST: 'positive_contrast',
  ATTENTION_CONTRAST: 'attention_contrast',
  MONO_600: 'mono_600',
  MONO_500: 'mono_500',
  MONO_900: 'mono_900'
};
export const SymbolSize = {
  SMALL: 32,
  REGULAR: 48,
  LARGE: 96,
  EXTRA_LARGE: 128
};
export const DEFAULT_SYMBOL_SIZE = SymbolSize.REGULAR;